import {request} from "@/api/request.js";
const Browse={
  getAll(tissue,sampleType,chr,start,length){
    return request.get("/snv_cpg",{
        tissue:tissue,
        sampleType:sampleType,
        chr:chr,
        start:start,length:length
    })
  },
    getElementByTissue(tissue){
        return request.get("/getElementByTissue",{
            tissue:tissue
        })
    },
  getAllBySearch(tissue,sampleType,chr,search,start,length){
      return request.get("/snv_cpg/search",{
          tissue:tissue,
          sampleType:sampleType,
          chr:chr,
          search:search,
          start:start,length:length
      })
  },
  getAllByCpG(cpgid,start,length){
    return request.get(
      "/snv_cpg/cpgId",
      {
        cpgId: cpgid,
        start: start,
        length: length
      }
    )
  }

}
export default Browse;
